import React, { useEffect, useState } from "react";
import MatchDetailsFormatCard from "../../../components/Dashboard/MatchSingleDetails/MatchDetailsFormatCard";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import { useParams } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Participants from "../../../components/Dashboard/Participants/Participants";
import MatchEntryModal from "../../../components/Modals/MatchEntryModal/MatchEntryModal";
import useAuth from "../../../hooks/useAuth";

import { useForm } from "react-hook-form";
import Loader from "../../../components/Loader";

import PlayerModal from "../../../components/Modals/PlayerModal";
import { useSocket } from "../../../context/SocketContext";

const SingleMatchDetails = () => {
  const { socket } = useSocket(); // Backend URL

  const axiosPrivate = useAxiosPrivate();
  const { authenticated } = useAuth();

  const [match, setMatch] = useState();
  const params = useParams();
  const [showPromotionModal, setShowPromotionModal] = useState(false);
  const [showWithdrawModal, setshowWithdrawModal] = useState(false);
  const [showPlayerModal, setshowPlayerModal] = useState(false);
  const [NewParticipants, setNewParticipants] = useState([]);
  const [matchDate, setMatchDate] = useState();
  const [createdMatchDate, setCreatedMatchDate] = useState();
  const [loading, setLoading] = useState(false);

  const handleOnClose = () => {
    setShowPromotionModal(false);
    setshowWithdrawModal(false);
    setshowPlayerModal(false);
  };

  useEffect(() => {
    // Fetch initial listings
    setLoading(true);
    const fetchListings = async () => {
      await axiosPrivate
        .get(`/listings/SingleMatchCard/${params.string}`, {
          withCredentials: true,
        })
        .then((res) => {
          console.log(res.data?.participants);
          setMatch(res.data);
          setNewParticipants(res.data?.participants);
          const date = new Date(res.data?.closingTime);
          const createdAt = new Date(res.data?.createdAt);
          const options = {
            month: "long", // Full month name
            day: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true, // Enable am/pm formatting
          };
          const formattedDate = date
            .toLocaleString("en-US", options)
            .replace(",", "");
          const formattedDateCreatedAt = createdAt
            .toLocaleString("en-US", options)
            .replace(",", "");

          setMatchDate(formattedDate);
          setCreatedMatchDate(formattedDateCreatedAt);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          console.log(err);
        });
    };

    fetchListings();
    return () => {};
  }, [axiosPrivate, params.string]);
  useEffect(() => {
    // Listen for real-time updates

    socket?.on("matchUpdated", (change) => {
      console.log("Real-time update received from matchUpdated:", change);

      if (
        change?.updateDescription?.updatedFields &&
        change?.documentKey?._id === match?._id
      ) {
        // change?.updateDescription?.updatedFields.participants
        setMatch((prevState) => ({
          ...prevState, // Spread the previous state
          ...change?.updateDescription?.updatedFields,
        }));

        console.log(change, "this is values");
      }
    });
    // if NewParticipants
    //filter userID,if present then stay on page or redirect and show toast message.

    // Cleanup on unmount
    return () => {
      socket?.off("matchUpdated");
    };
  }, [match, socket]);

  useEffect(() => {
    // Listen for real-time updates
    socket?.on("changeMatchParticipants", (change) => {
      console.log(
        "Real-time update received from matchUpdatedParticipants:",
        change
      );

      if (
        change?.change.updateDescription?.updatedFields &&
        change?.change.documentKey?._id === match?._id
      ) {
        // change?.updateDescription?.updatedFields.participants

        console.log(change?.populatedParticipants, "this is values");
        setNewParticipants(change?.populatedParticipants);
        console.log(NewParticipants, "this is participants");
      }
    });
    // if NewParticipants
    //filter userID,if present then stay on page or redirect and show toast message.

    // Cleanup on unmount
    return () => {
      socket?.off("changeMatchParticipants");
    };
  }, [NewParticipants, match?._id, socket]);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  return loading ? (
    <Loader />
  ) : (
    <>
      <div className="container mx-auto  ">
        <MatchEntryModal
          onClose={handleOnClose}
          visible={showPromotionModal}
          data={match}
          isWithdraw={false}
        />
        <MatchEntryModal
          onClose={handleOnClose}
          visible={showWithdrawModal}
          data={match}
          isWithdraw={true}
        />
        <PlayerModal
          onClose={handleOnClose}
          visible={showPlayerModal}
          data={match}
        />

        <div class=" ">
          <div>
            <h1 className="text-xl p-3 border">
              Match Will Start At : {matchDate}
            </h1>
          </div>
          <h1 class="text-lg text-center font-semibold my-6">Match status</h1>
          <div class="container h-[370px] overflow-scroll overflow-x-hidden">
            <div class="flex flex-col md:grid grid-cols-12 text-gray-50">
              {/* registration open ,status = "open" */}
              <div class="flex md:contents">
                <div class="col-start-2 col-end-4 mr-10 md:mx-auto relative">
                  <div class="h-full w-6 flex items-center justify-center">
                    <div class="h-full w-1 bg-green-500 pointer-events-none"></div>
                  </div>
                  <div class="w-6 h-6 absolute top-1/2 -mt-3 rounded-full bg-green-500 shadow text-center">
                    <i class="fas fa-check-circle text-white"></i>
                  </div>
                </div>
                <div class="bg-green-500 col-start-4 col-end-12 p-4 rounded-xl my-4 mr-auto shadow-md w-full">
                  <h3 class="font-semibold text-sm mb-1">Registration Open</h3>
                  <small>Registrations are open, book your slot now,</small>
                  <small class="leading-tight ms-1 text-justify text-xs w-full">
                    Registrations opened at : ({createdMatchDate})
                  </small>
                </div>
              </div>
              {/* registration open ,status = "readyDevice" */}
              <div class="flex md:contents">
                <div class="col-start-2 col-end-4 mr-10 md:mx-auto relative">
                  <div class="h-full w-6 flex items-center justify-center">
                    <div
                      class={`h-full w-1 ${
                        match?.status === "readyDevice"
                          ? "bg-green-500"
                          : "bg-white"
                      } pointer-events-none`}
                    ></div>
                  </div>
                  <div
                    class={`w-6 h-6 absolute top-1/2 -mt-3 rounded-full   ${
                      match?.status === "readyDevice"
                        ? "bg-green-500"
                        : "bg-white"
                    } shadow text-center`}
                  >
                    <i class="fas fa-check-circle text-white"></i>
                  </div>
                </div>
                <div
                  class={`${
                    match?.status === "readyDevice" ? "bg-green-500" : ""
                  } border col-start-4 col-end-12 p-4 rounded-xl my-4 mr-auto shadow-md w-full`}
                >
                  <h3 class="font-semibold  text-sm mb-1">
                    Ready device to play
                  </h3>
                  <small>Ready your devices so that you can now compete</small>
                  <small class="leading-tight ms-2 text-justify text-xs w-full">
                    {/* (21 July 2021, 04:30 PM) */}
                  </small>
                </div>
              </div>
              {/* registration open ,status = "started" */}
              <div class="flex md:contents">
                <div class="col-start-2 col-end-4 mr-10 md:mx-auto relative">
                  <div class="h-full w-6 flex items-center justify-center">
                    <div
                      class={`h-full w-1 ${
                        match?.status === "started"
                          ? "bg-green-500"
                          : "bg-white"
                      }   pointer-events-none`}
                    ></div>
                  </div>
                  <div
                    class={`w-6 h-6 absolute top-1/2 -mt-3 rounded-full   ${
                      match?.status === "started" ? "bg-green-500" : "bg-white"
                    } shadow text-center`}
                  >
                    <i class="fas fa-check-circle text-white"></i>
                  </div>
                </div>
                <div
                  class={`${
                    match?.status === "started" ? "bg-green-500" : ""
                  } border col-start-4 col-end-12 p-4 rounded-xl my-4 mr-auto shadow-md w-full`}
                >
                  <h3 class="font-semibold  text-sm mb-1 text-gray-50">
                    Seeding match
                  </h3>
                  <small>
                    The match has started, Good luck to all players!
                  </small>
                  <small class="leading-tight ms-2 text-justify text-xs w-full">
                    {/* (21 July 2021, 04:30 PM) */}
                  </small>
                </div>
              </div>
              {/* registration open ,status = "finished" */}
              <div class="flex md:contents">
                <div class="col-start-2 col-end-4 mr-10 md:mx-auto relative">
                  <div class="h-full w-6 flex items-center justify-center">
                    <div
                      class={`h-full w-1 ${
                        match?.status === "started"
                          ? "bg-green-500"
                          : "bg-white"
                      }   pointer-events-none`}
                    ></div>
                  </div>
                  <div
                    class={`w-6 h-6 absolute top-1/2 -mt-3 rounded-full   ${
                      match?.status === "finished" ? "bg-green-500" : "bg-white"
                    } shadow text-center`}
                  >
                    <i class="fas fa-check-circle text-white"></i>
                  </div>
                </div>
                <div
                  class={`${
                    match?.status === "finished" ? "bg-green-500" : ""
                  } border col-start-4 col-end-12 p-4 rounded-xl my-4 mr-auto shadow-md w-full`}
                >
                  {" "}
                  <h3 class="font-semibold  text-sm mb-1 text-white">
                    Conclusion
                  </h3>
                  <small>
                    The match has finished, Congratulation to the wining
                    players!
                  </small>
                  <small class="leading-tight ms-2 text-justify text-xs w-full">
                    {/* (21 July 2021, 04:30 PM) */}
                  </small>
                </div>
              </div>
            </div>
          </div>
          {authenticated?.user?.role === "admin" ? (
            <>
              <form
                className="mt-3"
                onSubmit={handleSubmit(async (data) => {
                  console.log(data, "this is date");
                  if (data.status === "readyDevice") {
                    const formDate = {
                      status: data.status,
                      roomId: data.roomId,
                      roomPassword: data.roomPassword,
                    };
                    await axiosPrivate
                      .put(
                        `/listings/updateMatchCard/${match?._id}`,
                        formDate,
                        {
                          withCredentials: true,
                        }
                      )
                      .then((res) => {
                        console.log(res.data);
                      })
                      .catch((err) => console.log(err));
                  } else {
                    const formDate = {
                      status: data.status,
                    };
                    await axiosPrivate
                      .put(
                        `/listings/updateMatchCard/${match?._id}`,
                        formDate,
                        {
                          withCredentials: true,
                        }
                      )
                      .then((res) => {
                        console.log(res.data);
                      })
                      .catch((err) => console.log(err));
                  }
                })}
              >
                <div className=" flex flex-col md:flex-row mt-2 justify-center items-center ">
                  <div className="me-2 my-2">
                    <label className="text-lg">Match Status : </label>
                  </div>
                  <div>
                    <div>
                      <select
                        {...register("status", {
                          required: "This field is required.",
                        })}
                        className={`block my-2 appearance-none w-full bg-gray-200 border border-gray-200 ${
                          errors.Country?.message ? "border-red-700" : null
                        } text-gray-700 py-3 px-4 pr-8  text-xs rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500 `}
                        id="grid-state-country"
                        defaultValue="Select Mode Type"
                      >
                        <option value="readyDevice">Ready Devices</option>
                        <option value="started">Seeding Match</option>
                        <option value="finished">finished Match</option>
                        <option value="cancelled">Cancelled Match</option>
                      </select>
                    </div>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                    <p className="text-red-500 text-xs italic">
                      {/* {errors.Country?.message} */}
                    </p>
                  </div>

                  <div>
                    <input
                      {...register("roomId", {})}
                      className={`block appearance-none w-full bg-gray-200 border border-gray-200 ${
                        errors.Country?.message ? "border-red-700" : null
                      } text-black py-3 my-2 px-1 pr-4 rounded text-xs leading-tight focus:outline-none focus:bg-white focus:border-gray-500 `}
                      id="grid-state-country"
                      placeholder="Room Id PUBG"
                    />
                  </div>
                  <div>
                    <input
                      {...register("roomPassword", {})}
                      className={`block appearance-none w-full bg-gray-200 border border-gray-200 ${
                        errors.Country?.message ? "border-red-700" : null
                      } text-black py-3 px-1 pr-4 rounded text-xs leading-tight focus:outline-none focus:bg-white focus:border-gray-500 `}
                      id="grid-state-country"
                      placeholder="Room Password"
                    />
                  </div>

                  <button className="mt-5 tracking-wide ms-5 flex justify-between px-3 font-semibold bg-purple-500 text-white-500 w-[200px] py-2 rounded-lg hover:bg-purple-700 hover:text-purple-800 transition-all duration-300 ease-in-out flex items-center justify-center focus:shadow-outline focus:outline-none">
                    <p> Update Now</p> <ArrowRight />
                  </button>
                </div>
              </form>
            </>
          ) : (
            ""
          )}
        </div>

        <div className="mt-10">
          <h4 className="text-lg">Format</h4>
        </div>
        <div className="grid md:grid-cols-4  grid-rows-1 gap-4 mt-4">
          <MatchDetailsFormatCard
            title="GAME"
            desc="PUBG MOBILE"
            svg="https://api.iconify.design/game-icons:gamepad.svg?color=%23ffffff"
          />
          <MatchDetailsFormatCard
            title="Type"
            desc={match?.type}
            svg="https://api.iconify.design/fluent:people-community-32-filled.svg?color=%23ffffff"
          />
          <MatchDetailsFormatCard
            title="Fees"
            desc={match?.fees}
            svg="https://api.iconify.design/tdesign:money.svg?color=%23ffffff"
          />
          <MatchDetailsFormatCard
            title="Total Slots"
            desc={match?.totalSlots}
            svg="https://api.iconify.design/material-symbols:account-tree-outline.svg?color=%23ffffff"
          />
          <MatchDetailsFormatCard
            title="Available Slots"
            desc={match?.totalSlots - NewParticipants?.length}
            svg="https://api.iconify.design/fluent:person-available-24-filled.svg?color=%23ffffff"
          />
          <MatchDetailsFormatCard
            title="Check-in period"
            desc="45 minutes before start"
            svg="https://api.iconify.design/material-symbols:nest-clock-farsight-analog-outline.svg?color=%23ffffff"
          />
          <MatchDetailsFormatCard
            title="Team size"
            desc={`${
              match?.type === "single"
                ? "1"
                : match?.type === "duo"
                ? "2"
                : match?.type === "squad"
                ? "4"
                : ""
            }`}
            svg="https://api.iconify.design/ph:microsoft-teams-logo-fill.svg?color=%23ffffff"
          />
          <MatchDetailsFormatCard
            title="Server/Region"
            desc={match?.server}
            svg="https://api.iconify.design/solar:server-2-bold.svg?color=%23ffffff"
          />
        </div>
        <div className="mt-10">
          <h4 className="text-lg">Players - {NewParticipants?.length}</h4>
        </div>
        <div className="w-full h-64 border rounded bg-black bg-opacity-50  flex justify-center items-center">
          <div class="flex overflow-x-scroll  hide-scroll-bar">
            <div class="flex flex-nowrap justify-center items-center ml-10 ">
              {NewParticipants?.length === 0 ? (
                <>
                  <p>No Participants yet.</p>
                </>
              ) : (
                NewParticipants?.map((user) => {
                  console.log(user, "this i suser ");
                  return (
                    <div class="inline-block px-3 ">
                      <Participants data={user} />
                    </div>
                  );
                })
              )}
            </div>
          </div>
        </div>
        <div className="mt-10">
          <h4 className="text-lg">Prize / Notes</h4>
        </div>
        <div className="w-full p-4  border rounded bg-black bg-opacity-50  flex ">
          <div className="flex flex-col">
            <p className="font-bold text-xl">Important Notes:</p>
            <p className="mt-2 text-lg">
              The Prize cash is divided into 3 parts.
            </p>
            <p className="mt-2 text-lg">
              1. If the participants are less then 10 then the match will not
              start and all balance will be given back to players.
            </p>
            <p className="mt-2 text-lg">
              2. The total prize cash will be 70% of the total players at
              closing time. e.g 70% of 1000 (PKR) = 700 (PKR).
            </p>
            <p className="mt-2 text-lg">
              3. First player will get 40% of the prize. e.g 40% of 1000 (PKR) =
              400 (PKR).
            </p>
            <p className="mt-2 text-lg">
              4. Seccond player will get 20% of the prize. e.g 20% of 1000 (PKR)
              = 200 (PKR).
            </p>
            <p className="mt-2 text-lg">
              5. Third player will get 10% of the prize. e.g 20% of 1000 (PKR) =
              100 (PKR).
            </p>
            <p className="mt-2 text-lg flex me-1">
              6.
              <strong className="flex mx-1">
                <p className="underline mx-1">Kills </p> are not important only
                winning is important.
              </strong>
            </p>
            <p className="mt-2 text-lg">
              7.
              <strong>
                {" "}
                If we find out that the room password has been shared to someone
                who is not in our database we will kick him out immediately and
                also find the person who shared it and block his account.
              </strong>
            </p>
          </div>
        </div>

        {/* <PlayerFinalSection match={match} state={setshowPlayerModal} /> */}
        <div className="mt-10">
          <h4 className="text-lg">Results</h4>
        </div>
        <div
          className={`w-full ${
            match?.winners.length > 0 ? "py-4" : "h-64"
          } border rounded bg-black bg-opacity-50  flex justify-center items-center`}
        >
          <div class="flex overflow-x-scroll  hide-scroll-bar">
            <div class="flex flex-nowrap justify-center items-center ml-10 ">
              {authenticated?.user?.role === "admin" ? (
                <>
                  {match?.winners
                    ? match?.winners.map((user) => {
                        console.log(user, "this is user winners ");
                        return (
                          <div class="inline-block px-3 ">
                            <Participants
                              data={user.id}
                              Winnertype={user.type}
                              prize={user.balance}
                              team={user.team}
                            />
                          </div>
                        );
                      })
                    : ""}
                  <button
                    onClick={() => {
                      setshowPlayerModal(true);
                    }}
                  >
                    <img
                      src="https://api.iconify.design/material-symbols:add-circle-rounded.svg?color=%2304ff00"
                      className="h-[30px]"
                      alt=""
                    />
                  </button>
                </>
              ) : authenticated?.user?.role === "user" &&
                match?.type === "single" ? (
                <>
                  {match?.winners.length > 0 ? (
                    match?.winners.map((user) => {
                      console.log(user, "this is user winners ");
                      return (
                        <div class="inline-block px-3 ">
                          <Participants
                            data={user.id}
                            Winnertype={user.type}
                            prize={user.balance}
                          />
                        </div>
                      );
                    })
                  ) : (
                    <>
                      {" "}
                      <p className="">
                        Once the match has conculuded, the results will be shown
                        here.
                      </p>
                    </>
                  )}
                </>
              ) : (authenticated?.user?.role === "user" &&
                  match?.type === "duo") ||
                match?.type === "squad" ? (
                <>
                  {match?.winners.length > 0 ? (
                    match?.winners.map((user) => {
                      console.log(user, "this is user winners ");
                      return (
                        <div class="inline-block px-3 ">
                          <Participants
                            data={user.id}
                            Winnertype={user.type}
                            prize={user.balance}
                            team={user.team}
                          />
                        </div>
                      );
                    })
                  ) : (
                    <>
                      {" "}
                      <p className="">
                        Once the match has conculuded, the results will be shown
                        here.
                      </p>
                    </>
                  )}
                </>
              ) : (
                <>
                  {" "}
                  <p className="">
                    Once the match has conculuded, the results will be shown
                    here.
                  </p>
                </>
              )}
            </div>
          </div>
        </div>

        <div className="mt-10">
          <h4 className="text-lg">Hosted By : ADMIN</h4>
        </div>
        <div className="container flex justify-center items-center mt-4">
          {authenticated?.user?.role === "admin" ? (
            <>
              <button
                onClick={() => {
                  // setshowWithdrawModal(true);
                }}
                className="mt-5 tracking-wide flex justify-between px-3 font-semibold bg-red-500 text-white-500 w-[200px] py-4 rounded-lg hover:bg-red-700 hover:text-white transition-all duration-300 ease-in-out flex items-center justify-center focus:shadow-outline focus:outline-none"
              >
                <p> Delete Match</p> <ArrowRight />
              </button>
            </>
          ) : match?.status === "started" ||
            match?.status === "finished" ||
            match?.status === "closed" ? (
            ""
          ) : match?.participants?.filter(
              (participantId) => participantId._id === authenticated?.user?._id
            ).length > 0 ? (
            <button
              onClick={() => {
                setshowWithdrawModal(true);
              }}
              className="mt-5 tracking-wide flex justify-between px-3 font-semibold bg-red-500 text-white-500 w-[200px] py-4 rounded-lg hover:bg-red-700 hover:text-white transition-all duration-300 ease-in-out flex items-center justify-center focus:shadow-outline focus:outline-none"
            >
              <p> Withdraw Participation</p> <ArrowRight />
            </button>
          ) : (
            <button
              onClick={() => {
                setShowPromotionModal(true);
              }}
              className="mt-5 tracking-wide flex justify-between px-3 font-semibold bg-purple-500 text-white-500 w-[200px] py-4 rounded-lg hover:bg-purple-700 hover:text-purple-800 transition-all duration-300 ease-in-out flex items-center justify-center focus:shadow-outline focus:outline-none"
            >
              <p> Join Now</p> <ArrowRight />
            </button>
          )}
        </div>
      </div>
    </>
  );
};

export default SingleMatchDetails;
